
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 20H9a1 1 0 01-2 0H5a2 2 0 01-2-2V5a2 2 0 012-2h13a2 2 0 012 2v2a1 1 0 010 2v5a1 1 0 010 2v2a2 2 0 01-2 2h-2a1 1 0 01-2 0zm-4-8.505a3 3 0 10.877-2.12A3 3 0 0010 11.5v-.005zM7 11v1a1 1 0 002 0v-1a1 1 0 00-2 0zm4.715.5a1.285 1.285 0 112.572-.008 1.285 1.285 0 01-2.573.008h.001z"}})])
          )
        }
      }
    